'use client'

import React, { FC, ReactElement } from 'react'
import RankPill from '@/components/rank-pill'
import SatributePill from '@/components/satribute-pill'
import { Inscription } from '@/utils/types/inscription'
import classnames from 'classnames'

const RarityPills: FC<{ inscription: Inscription; className?: string; pillClassName?: string }> = (
	props
): ReactElement => {
	const { meta, satributes } = props?.inscription

	return (
		<>
			{false && meta?.rank && satributes?.length == 0 && (
				<RankPill
					className={classnames({ [(props?.className as any)]: !!props?.className })}
					rank={meta?.rank}
				/>
			)}
			{(satributes as any)?.length > 0 && (
				<SatributePill
					className={classnames({
						[(props?.className as any)]: !!props?.className,
						[(props?.pillClassName as any)]: !!props?.pillClassName
					})}
					sat={satributes}
				/>
			)}
		</>
	)
}

export default RarityPills
